export const OPEN_SIDE_PANE = 'OPEN_SIDE_PANE'
export const openSidePane = (selected) => ({ type: OPEN_SIDE_PANE, selected })

export const CLOSE_SIDE_PANE = 'CLOSE_SIDE_PANE'
export const closeSidePane = () => ({ type: CLOSE_SIDE_PANE })

export const TOGGLE_SIDE_PANE = 'TOGGLE_SIDE_PANE'
export const toggleSidePane = () => ({ type: TOGGLE_SIDE_PANE })
